// extracted by mini-css-extract-plugin
export default {"list":"IzNju_sULv"};